import React, { useLayoutEffect } from 'react';
import {
  Content,
  ContentContainer,
  PageContainer,
  Title,
  BoldText,
  Text,
  StyledSubtitle,
  StyledCallToAction,
} from './Hikes.styles';
import { useTranslation } from 'react-i18next';
import { PhotoGallery } from './PhotoGallery';
import { imagesTatry2 } from './images';

export const Tatry2 = () => {
  const { t } = useTranslation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <ContentContainer>
        <Content>
          <Title>{t('hiking.tatry2')}</Title>
          <BoldText>{t('hiking.destination-tatry2')}</BoldText>
          <BoldText>{t('hiking.date-tatry2')}</BoldText>
          <Text>{t('tatry2.description')}</Text>
          <StyledSubtitle>{t('tatry2.subtitle1')}</StyledSubtitle>
          <Text>{t('tatry2.description0')}</Text>
          <StyledSubtitle>{t('tatry2.subtitle2')}</StyledSubtitle>
          <Text>{t('tatry2.description1')}</Text>
          <StyledSubtitle>{t('tatry2.subtitle3')}</StyledSubtitle>
          <Text>{t('tatry2.description2')}</Text>
          <Text>{t('tatry2.description3')}</Text>

          <StyledSubtitle>{t('tatry2.subtitle4')}</StyledSubtitle>
          <Text>{t('tatry2.description4')}</Text>

          <StyledCallToAction>
            <StyledSubtitle>{t('tatry2.cta')}</StyledSubtitle>
          </StyledCallToAction>
          <PhotoGallery images={imagesTatry2} />
        </Content>
      </ContentContainer>
    </PageContainer>
  );
};
